const e=Object.freeze({ROUTES:Object.freeze({FORGOT_PASSWORD:"/forgot-password",IMPERSONATED_USER_LOGOUT:"/impersonated-user-logout",LOGIN:"/login",LOGOUT:"/logout",PROFILE:"/profile",REGISTER:"/register"})});export{e as USE_IDENTITY_SITE_URLS_CONSTANTS};
//# sourceMappingURL=useIdentitySiteUrls.constants.js.map
